import { defineInternalTask } from '../../../config/types';
import { internalTasks, reviewTeams } from '../../../config/constants';

import { baseBindState, getPrimarySegment } from './lib/helpers';

export const distanceToFireHydrant = defineInternalTask({
  taskName: internalTasks.DistanceToFireHydrant,
  config: {
    staffDisplayName: 'Distance to Fire Hydrant: verification needed',
    reviewTeam: reviewTeams.uwOps,
    policyTypes: ['H'],
    enabled: true,
    trigger: ({ policy, offer }) => {
      const segment = getPrimarySegment(policy);
      const home = segment?.home;
      const offerHome = offer?.quote?.home;

      if (offerHome?.inspectionOrdered) {
        return null;
      }

      const fireHydrantWithin1000ft = home?.fireHydrantWithin1000ft ?? offerHome?.fireHydrantWithin1000ft;
      const fpcFromLocation = home?.fpcFromLocation ?? offerHome?.fpcFromLocation;

      // Split-class FPC values look like "5/9" — only those need manual verification.
      if (!fireHydrantWithin1000ft || !String(fpcFromLocation || '').includes('/')) {
        return null;
      }

      return { data: {}, bindState: baseBindState(policy) };
    },
    description: () =>
      'This policy claims to be within 1000ft of a fire hydrant, but our data vendor does not have such a hydrant in its database, and we did not order an inspection, so we need independent verification of the hydrant proximity. Please order an inspection (if needed) based on findings of the investigation.'
  }
});
